import http from "./http";

/* =========================
   LEADS
========================= */
export const getLeads = async () => {
  const res = await http.get("leads?action=get");
  return res.data;
};

export const getLeadsForAssign = async () => {
  const res = await http.get("leads?action=get");
  return res.data;
};

export const getLeadById = async (id) => {
  const res = await http.get(`leads?action=get_single&id=${id}`);
  return res.data;
};

export const addLead = async (payload) => {
  const res = await http.post(
    "leads?action=add",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

export const updateLead = async (payload) => {
  const res = await http.post(
    "leads?action=update",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

export const deleteLead = async (id) => {
  const res = await http.post("leads?action=delete", { id });
  return res.data;
};

/* =========================
   USERS / TEAM
========================= */
export const getTeamManagers = async () => {
  const res = await http.post("tm_sale_all_user?action=tm");
  return res.data;
};

export const getSalesUsers = async () => {
  const res = await http.post("tm_sale_all_user?action=sales");
  return res.data;
};

export const getUsers = async () => {
  const res = await http.post("users?action=get_users");
  return res.data;
};

/* =========================
   ASSIGNMENT (ALL)
========================= */

// OLD – single assign (USED BY OLD COMPONENTS)
export const assignLead = async ({ lead_id, tm_id }) => {
  const res = await http.post("leads?action=assign", {
    lead_id,
    tm_id,
  });
  return res.data;
};

// OLD – multi assign
export const assignLeadsMulti = async (payload) => {
  const res = await http.post(
    "leads?action=assign_multi",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

// Assign Team Manager
export const assignLeadsToTM = async ({ tm_id, lead_ids }) => {
  const res = await http.post(
    "leads?action=assign_multiple",
    { tm_id, lead_ids },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

// Assign Sales Executive (🔥 NEW API)
export const assignSalesLeads = async ({ sales_id, lead_ids }) => {
  const res = await http.post(
    "assign-sales-leads",
    { sales_id, lead_ids },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

// Assign Normal User
export const assignLeadsToUser = async ({ user_id, role, lead_ids }) => {
  const res = await http.post(
    "assign_leads?action=assign",
    { user_id, role, lead_ids },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

export const reassignLeadsToUser = async ({ user_id, role, lead_ids }) => {
  const res = await http.post(
    "reassign_leads.php",
    { action: "reassign", user_id, role, lead_ids },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

export const unassignLeads = async (lead_ids) => {
  const res = await http.post(
    "reassign_leads.php",
    { action: "unassign", lead_ids },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

export const getSalesByTM = async (tm_id) => {
  const res = await http.get(`assignUserToTM?tm_id=${tm_id}`);
  return res.data;
};



/* =========================
   CSV UPLOAD
========================= */
export const uploadLeadsCSV = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await http.post(
    "leads?action=upload_csv",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

  return res.data;
};

/* =========================
   FOLLOWUPS
========================= */
export const getFollowups = async ({ from, to, status }) => {
  const STATUS_MAP = {
    hot: 1,
    warm: 2,
    cold: 3,
  };

  const statusValue = STATUS_MAP[status];

  const res = await http.get(
    `leads?action=followups&from=${from}&to=${to}&status=${statusValue}`
  );

  return res.data;
};

/* =========================
   LEAD STATUS
========================= */
export const getLeadStatuses = async () => {
  const res = await http.get("lead_status?action=get");
  return res.data;
};

export const addLeadStatus = async (payload) => {
  const res = await http.post(
    "lead_status?action=add",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

export const deleteLeadStatus = async (id) => {
  const res = await http.post(
    "lead_status?action=delete",
    { id },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

/* =========================
   LEAD NOTES
========================= */
export const getLeadNotes = async (lead_id) => {
  const res = await http.post(
    `leads?action=get_notes&lead_id=${lead_id}`
  );
  return res.data;
};

export const addLeadNote = async ({ lead_id, note }) => {
  const res = await http.post(
    "leads?action=add_note",
    { lead_id, note },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};


// ... existing imports ...

// 🔥 NEW: Multiple Lead Delete API
export const deleteMultipleLeads = async (lead_ids) => {
  const res = await http.post(
    "leads?action=delete_multiple",
    { lead_ids },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

// ... rest of your existing service code ...


